var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('img',{staticClass:"cursor-pointer mr-3",staticStyle:{"margin-left":"-5px"},attrs:{"src":hover ? require('@/assets/img/ico/loeschen-hover.svg') : require('@/assets/img/ico/loeschen.svg'),"width":"27"},on:{"click":_vm.deleteArticle}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }